let docWidth = window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;

if (docWidth < 1200) {
	let mmenu = $('#mobile-menu').mmenu({
		navbar: {
			title: ''
		},
	}, {
		clone: false,
		panelNodetype: 'ul,ol',
	});
	window.mmenu_api = mmenu.data('mmenu');
	let mobileMenu = $('#mobile-menu');
	mobileMenu.removeClass('mm-hidden');

	// Changing the text on the backbuttons by replacing the sr only link with a visible back btn with text
	if($('.js-mmenu-btn-back-text').text().length > 0) {
		$('#mobile-menu .mm-panel_has-navbar .mm-navbar .mm-btn_prev').text(
			$('.js-mmenu-btn-back-text').text()
		);
	}

	let toggleMmenu = function() {
		if ($('#mobile-menu').hasClass('mm-menu_opened')) {
			window.mmenu_api.close();
			// immediately remove this class or user sees a significant delay in closing the menu
			mobileMenu.removeClass('mm-menu_opened');
		} else {
			window.mmenu_api.open();
		}
	};

	$('#backdrop').on('click', () => {
		if ($('#langSwitchPopover').hasClass('toggled')) {
			$('.icon__header--lang-switch').trigger('click');
		} else if ($('#mobile-menu').hasClass('mm-menu_opened')) {
			toggleMmenu();
		}  // else: inline menu is clicked
	});

	$('.main-navi-button').on('click', () => {
		// if navigation is requested but the langswitch still open
		// trigger the collapse of the lang switch first
		if ($('#langSwitchPopover').hasClass('toggled')) {
			$('.icon__header--lang-switch').trigger('click');
		}
		toggleMmenu();
	});

	// When the langswitch is clicked, it should close a potentially open menu
	$('.icon__header--lang-switch').on('click', () => {
		if ($('#mobile-menu').hasClass('mm-menu_opened')) {
			window.mmenu_api.close();
			// immediately remove this class or user sees a significant delay in closing the menu
			mobileMenu.removeClass('mm-menu_opened');
		}
	});

	// Links underneath the open menu/backdrop are still clickable - prevent the 
	// default location and trigger click on the lang-switch/backdrop depending on what was opened langswitch or navigation
	$('main a').on('click', (el) => {
		if (document.body.classList.contains('backdrop-active') && !$('.product-navigation__button').hasClass('clicked')) {
			el.preventDefault();
			if ($('#langSwitchPopover').hasClass('toggled')) {
				$('.icon__header--lang-switch').trigger('click');
			} else {
				$('#backdrop').trigger('click');
			}
		}
	});
}